import React, { useState } from "react";
import { Link } from "react-router-dom";
import RegisterStyles from "./Register.module.css";
import DisclaimerFooter from "../DisclaimerFooter/DisclamerFooter";
import Logo from "../../assets/Logo.svg";
import { getSessionStorage } from "../../sagas/utils";
import { Input, Icon, Button, Form } from "antd";

interface LoginProps {
  form: {
    getFieldsError: Function;
    getFieldDecorator: Function;
    validateFields: Function;
  };
  emailAddress: string;
  registerUser: Function;
}

type RegisterValues = {
  siteId: string;
  email: string;
};

function hasErrors(fieldsError: any) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

const Register: React.FC<LoginProps> = ({
  form: { getFieldsError, getFieldDecorator, validateFields },
  registerUser,
  emailAddress
}) => {
  const handleSubmit = (e: any) => {
    e.preventDefault();
    validateFields((err: Object, values: RegisterValues) => {
      if (!err) {
        registerUser({ email: values.email, siteID: values.siteId });
      }
    });
  };

  const validateSideId = (
    rule: string,
    value: string,
    callback: Function
  ): void => {
    if (/M02-[A-Za-z]{2}1[0-9]{5}/g.test(value)) {
      callback();
    } else {
      callback("Please enter a correctly formatted site ID.");
    }
  };

  return (
    <div className={RegisterStyles.HomeContainer}>
      <DisclaimerFooter className={RegisterStyles.disclaimer} />
      <img src={Logo} className={RegisterStyles.logo} />
      <Form onSubmit={handleSubmit} className={RegisterStyles.form}>
        <Form.Item className={RegisterStyles.fieldItem}>
          {getFieldDecorator("email", {
            rules: [{ required: true, message: "Please input an email" }]
          })(
            <Input
              name="email"
              placeholder="EMAIL"
              type="email"
              className={RegisterStyles.input}
              prefix={<Icon type="mail" className={RegisterStyles.icon} />}
            />
          )}
        </Form.Item>
        <Form.Item className={RegisterStyles.fieldItem}>
          {getFieldDecorator("siteId", {
            rules: [
              {
                required: true,
                validator: validateSideId
              }
            ]
          })(
            <Input
              name="siteId"
              placeholder="CLINICAL SITE ID"
              className={RegisterStyles.input}
              prefix={
                <Icon type="environment" className={RegisterStyles.icon} />
              }
            />
          )}
        </Form.Item>
        <Button
          type="primary"
          size="large"
          htmlType="submit"
          className={RegisterStyles.loginButton}
          disabled={hasErrors(getFieldsError())}
        >
          Register
        </Button>
      </Form>
      <footer className={RegisterStyles.messageLogIn}>
        Have trouble logging in? Please contact <a>support@sibelhealth.com</a>
      </footer>
    </div>
  );
};

export default Form.create({ name: "RegisterForm" })(Register);
